import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface FilterState {
    lines: string[]
    sources: string[]
}

const initialState: FilterState = {
    lines: [],
    sources: [],
}

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setLines: (state, action: PayloadAction<{ lines: string[] }>) => {
            state.lines = action.payload.lines
        },
        setSources: (state, action: PayloadAction<{ sources: string[] }>) => {
            state.sources = action.payload.sources
        },
    },
})

export const { setLines, setSources } = filterSlice.actions

export default filterSlice.reducer
